import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

function CancelBtn({ onClick }) {
  return (
    <Button
      className="d-flex justify-content-center align-items-center"
      variant="outline-danger"
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}>
      <FormattedMessage id="button.cancel" />
    </Button>
  );
}

export default CancelBtn;
